import axios from '../axios';
import {
  ADD_PRODUCT,
  GET_PRODUCT_CATEGORIES,
  DELETE_PRODUCT,
  UPLOAD_IMAGE_CLOUDINARY,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_MERCHANT_STATUS,
} from '../ApiUrl';

// Hedaer is added just for testing to capture header getting with this API,we can also pass header with mob header extention
export const AddProductAPI = async (payload) => {
  try {
    const response = await axios.post(ADD_PRODUCT, payload, {
      headers: {
        syed: 'syed',
      },
    });
    return response;
  } catch (error) {
    console.log('AddProductAPI  catch block', error);
    return { success: false, error };
  }
};

export const GetProductCategoryAPI = async () => {
  try {
    const response = await axios.get(GET_PRODUCT_CATEGORIES);
    return response;
  } catch (error) {
    console.log('GetProductCategoryAPI catch block', error);
    return { success: false, error };
  }
};

export const DeleteProductAPI = async (payload) => {
  try {
    const response = await axios.patch(DELETE_PRODUCT, payload);
    return response;
  } catch (error) {
    console.log('DeleteProductAPI catch block', error);
    return { success: false, error };
  }
};


export const UploadImageCloudinaryAPI = async (payload) => {
  try {
    const response = await axios.post(UPLOAD_IMAGE_CLOUDINARY, payload);
    return response;
  } catch (error) {
    console.log('UploadImageCloudinaryAPI  catch block', error);
    return { success: false, error };
  }
};

export const UpdateProductAPI = async (payload) => {
  try {
    const response = await axios.put(UPDATE_PRODUCT, payload);
    return response;
  } catch (error) {
    console.log('UpdateProductAPI catch block', error);
    return { success: false, error };
  }
};

export const UpdateProductStatusAPI = async (payload) => {
  try {
    const response = await axios.put(UPDATE_PRODUCT_MERCHANT_STATUS, payload);
    return response;
  } catch (error) {
    console.log('UpdateProductStatusAPI catch block', error);
    return { success: false, error };
  }
};
